import axios from "../../services/axiosService";
import { Dispatch } from "redux";
import { ActionType } from "../action-types/index";
import { Action } from "../actions/AuthAction";
import { ICreateSellerProfile } from "../../interfaceModules/IUserInterface";
import { useEffect, useState, useRef, useCallback} from "react";
const URL = process.env.REACT_APP_API_URL;

/**
 * create seller profile
 * @param data
 * @returns
 */
export const createSeller = (data: ICreateSellerProfile,tok:string,idProof:string) => async (
  dispatch: Dispatch<Action>
) => {
  console.log('data :>> ', data);
  console.log('token :>> ', tok);

  let obj  = tok === "BankAccount" ? {
    sellerInfo : {
      userId: data?.userId,
      firstname:data?.firstname,
      lastname:data?.lastname,
      email:data?.email,
      dob:{
            day:data?.day,
            month:data?.month,
            year:data?.year
        },
      phone_number:data?.phone_number,
      description:data?.description,
      image:data?.image,
      address:{
            line1:data?.address,
            city:data?.city,
            state:data?.state,
            zip_code:data?.zip_code,
            country:data?.country,
            currency:data?.currency
        },
      latitude:data?.latitude,
      longitude:data?.longitude,
      tax_id:data?.tax_id,
      id_number: data?.id_number, 
      routing_number: data?.routing_number, 
      account_number: data?.account_number, 
      id_proof: idProof
    } } : {
      sellerInfo : {
        userId: data?.userId,
        firstname:data?.firstname,
        lastname:data?.lastname,
        email:data?.email,
        dob:{
              day:data?.day,
              month:data?.month,
              year:data?.year
          },
        phone_number:data?.phone_number,
        description:data?.description,
        image:data?.image,
        address:{
              line1:data?.address,
              city:data?.city,
              state:data?.state,
              zip_code:data?.zip_code,
              country:data?.country,
          },
        latitude:data?.latitude,
        longitude:data?.longitude,
        tax_id:data?.tax_id,
        ssn_last_4:data?.snn,
        ssn:"",
        token: tok
      }
  }
  try {
    console.log('data :>>>>>>>>>>>>>SAK>>> ', obj);
    let url = `${URL}/api/v1/seller/add`
    const response = await axios.post(url, obj);
    console.log('response :>> ', response);
    return response.data;
  } catch (err) {
    console.log('dataoooo :>> ', err);
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};

export const editSeller = (data: ICreateSellerProfile,tok:string) => async (
  dispatch: Dispatch<Action>
) => {
  console.log('data :>> ', data);
  console.log('token :>> ', tok);
  
  let obj = {
    sellerInfo : {
      firstname:data?.firstname,
      lastname:data?.lastname,
      email:data?.email,
      dob:{
            day:data?.day,
            month:data?.month,
            year:data?.year
        },
      phone_number:data?.phone_number,
      address:{
            line1:data?.address,
            city:data?.city,
            state:data?.state,
            zip_code:data?.zip_code,
            country:data?.country
        },
      ssn_last_4:data?.snn,
      token: tok
    }
  }
  try {
    console.log('data :>> ', obj);
    let url = `${URL}/api/v1/seller/edit`
    const response = await axios.post(url, obj);
    console.log('response :>> ', response);
    return response.data;
  } catch (err) {
    console.log('dataoooo :>> ', err);
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};

/**
 * get details of seller
 * @param sellerId
 * @returns
 */
export const getSellerDetail = (sellerId: number) => async (
  dispatch: Dispatch<Action>
) => {
  try {
    const response = await axios.get(`${URL}/api/v1/seller/${sellerId}`);
    return response.data;
  } catch (err) {
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};


/**
 * get product list by SellerId
 * @param SellerId
 * @returns
 */

export const getProductListBySellerId = (sellerId: number, offset: number) => async (
  dispatch: Dispatch<Action>
) => {
  try {
    const response = await axios.get(`${URL}/api/v1/product/product-list/${sellerId}/?offset=${offset}`);
    // console.log("RESPONSRREEEEEEEEEE",response)
    console.log("SAK----->-->",response)
    return response.data.data.data;
  } catch (err) {
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};